import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import AdminMeetingCalendar from "./AdminMeetingCalendar";

const AdminPanel = () => {
  const { isAdmin } = useContext(AuthContext);
  if (!isAdmin) return null;
  return (
    <div className="admin-container">
      <div className="max-w-7xl w-full bg-white shadow-lg rounded-xl p-4 sm:p-6 space-y-6">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 text-center">
          Admin Dashboard
        </h2>

        <div className="grid grid-cols-1 gap-3 sm:flex sm:flex-wrap sm:justify-center mt-6 sm:mt-8">
          <Link
            to="/admin/therapists"
            className="px-5 py-3 sm:py-2 bg-slate-800 text-center text-white rounded-xl shadow hover:bg-slate-900 transition"
          >
            Therapists
          </Link>
          <Link
            to="/admin/schedule"
            className="px-5 py-3 sm:py-2 bg-blue-600 text-center text-white rounded-xl shadow hover:bg-blue-700 transition"
          >
            Schedule Session
          </Link>
          <Link
            to="/admin/resendpassword"
            className="px-5 py-3 sm:py-2 bg-purple-600 text-center text-white rounded-xl shadow hover:bg-purple-700 transition"
          >
            Resend Temp Password
          </Link>
          <Link
            to="/admin/register-user"
            className="px-5 py-3 sm:py-2 bg-green-600 text-center text-white rounded-xl shadow hover:bg-green-700 transition"
          >
            Register User
          </Link>
          <Link
            to="/admin/account-lookup"
            className="px-5 py-3 sm:py-2 bg-cyan-600 text-center text-white rounded-xl shadow hover:bg-cyan-700 transition"
          >
            Account Lookup
          </Link>
          <Link
            to="/admin/presignlinkgenerator"
            className="px-5 py-3 sm:py-2 bg-orange-600 text-center text-white rounded-xl shadow hover:bg-orange-700 transition"
          >
            Presign Link Generator
          </Link>
        </div>
        <AdminMeetingCalendar />
      </div>
    </div>
  );
};

export default AdminPanel;
